import { render, staticRenderFns } from "./TabelaFreteDetalhes.vue?vue&type=template&id=b45f173e"
import script from "./TabelaFreteDetalhes.vue?vue&type=script&lang=js"
export * from "./TabelaFreteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports